/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import * as z from "zod/v4-mini";
import { safeParse } from "../../lib/schemas.js";
import { Result as SafeParseResult } from "../../types/fp.js";
import { SDKValidationError } from "../errors/sdkvalidationerror.js";
import {
  ClaudeToolUsage,
  ClaudeToolUsage$inboundSchema,
} from "./claudetoolusage.js";
import {
  ClaudeTurnUsage,
  ClaudeTurnUsage$inboundSchema,
} from "./claudeturnusage.js";

export type ClaudeAgentUsage = {
  /**
   * Per-tool Claude usage keyed by tool_use_id.
   */
  tools: Array<ClaudeToolUsage>;
  /**
   * Per-prompt Claude usage turns ordered by start time.
   */
  turns: Array<ClaudeTurnUsage>;
};

/** @internal */
export const ClaudeAgentUsage$inboundSchema: z.ZodMiniType<
  ClaudeAgentUsage,
  unknown
> = z.object({
  tools: z.array(ClaudeToolUsage$inboundSchema),
  turns: z.array(ClaudeTurnUsage$inboundSchema),
});

export function claudeAgentUsageFromJSON(
  jsonString: string,
): SafeParseResult<ClaudeAgentUsage, SDKValidationError> {
  return safeParse(
    jsonString,
    (x) => ClaudeAgentUsage$inboundSchema.parse(JSON.parse(x)),
    `Failed to parse 'ClaudeAgentUsage' from JSON`,
  );
}
